import { memo } from 'react';
import { getSmoothStepPath } from '../../core';
import { BaseEdge } from '../BaseEdge';
import type { EdgeComponentProps } from '../BezierEdge';

export type SmoothStepEdgeProps = EdgeComponentProps & { borderRadius?: number };

/** A right-angled edge with rounded corners (v11 `smoothstep`). */
const SmoothStepEdgeComponent = ({ id, style, markerStart, markerEnd, borderRadius, ...position }: SmoothStepEdgeProps) => {
  const [path] = getSmoothStepPath({ ...position, borderRadius });
  return <BaseEdge id={id} path={path} style={style} markerStart={markerStart} markerEnd={markerEnd} />;
};

export const SmoothStepEdge = memo(SmoothStepEdgeComponent);

const SHARP_CORNERS = 0;

/** A right-angled edge with sharp corners (v11 `step`). */
const StepEdgeComponent = (props: EdgeComponentProps) => <SmoothStepEdge {...props} borderRadius={SHARP_CORNERS} />;

export const StepEdge = memo(StepEdgeComponent);
